const wordList = [
  'rome',
  'dog',
  'cat',
  'america',
  'mountain',
  'helicopter',
  'gold',
  'diamond',
  'egypt',
  'AC/DC',
  'pickaxe',
  'stop sign',
  'sidewalk',
  'monitor',
  'hanger',
  'bottle',
  'table',
  'piano',
  'remote',
  'ipod',
  'glasses',
  'wallet',
  'paper',
  'brocolli',
  'carrots',
  'conditioner',
  'puddle',
  'wagon',
  'thermometer',
  'bracelet',
  'street lights',
  'sidewalk',
  'balloon',
  'shirt',
  'katana',
  'sticky note',
  'helmet',
  'bookmark',
  'minecraft',
  'perfume',
  'ship',
];

// change this to api or a file or any thing

function threeRandomWordsGenerator() {
  let threeWords = [];
  for (let index = 0; index < 3; index++) {
    threeWords.push(wordList[Math.floor(Math.random() * wordList.length)]);
  }
  //   console.log(threeWords);
  return threeWords;
}

module.exports = {
  threeRandomWordsGenerator,
};
